"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticDatasourceToJSON = exports.DiagnosticDatasourceFromJSONTyped = exports.DiagnosticDatasourceFromJSON = exports.instanceOfDiagnosticDatasource = void 0;
var runtime_1 = require("../runtime");
var DatasourceType_1 = require("./DatasourceType");
var DiagnosticEvents_1 = require("./DiagnosticEvents");
var Granularity_1 = require("./Granularity");
/**
 * Check if a given object implements the DiagnosticDatasource interface.
 */
function instanceOfDiagnosticDatasource(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDiagnosticDatasource = instanceOfDiagnosticDatasource;
function DiagnosticDatasourceFromJSON(json) {
    return DiagnosticDatasourceFromJSONTyped(json, false);
}
exports.DiagnosticDatasourceFromJSON = DiagnosticDatasourceFromJSON;
function DiagnosticDatasourceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'datasourceType': !(0, runtime_1.exists)(json, 'datasource_type') ? undefined : (0, DatasourceType_1.DatasourceTypeFromJSON)(json['datasource_type']),
        'datasourceId': !(0, runtime_1.exists)(json, 'datasource_id') ? undefined : json['datasource_id'],
        'granularity': !(0, runtime_1.exists)(json, 'granularity') ? undefined : (0, Granularity_1.GranularityFromJSON)(json['granularity']),
        'timeseries': !(0, runtime_1.exists)(json, 'timeseries') ? undefined : (json['timeseries'].map(DiagnosticEvents_1.DiagnosticEventsFromJSON)),
    };
}
exports.DiagnosticDatasourceFromJSONTyped = DiagnosticDatasourceFromJSONTyped;
function DiagnosticDatasourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'datasource_type': (0, DatasourceType_1.DatasourceTypeToJSON)(value.datasourceType),
        'datasource_id': value.datasourceId,
        'granularity': (0, Granularity_1.GranularityToJSON)(value.granularity),
        'timeseries': value.timeseries === undefined ? undefined : (value.timeseries.map(DiagnosticEvents_1.DiagnosticEventsToJSON)),
    };
}
exports.DiagnosticDatasourceToJSON = DiagnosticDatasourceToJSON;
